import React from 'react';
import {
  localization,
  PropertyGridEditorCollection,
  SurveyQuestionEditorDefinition,
} from 'survey-creator-react';
import { ElementFactory, Question, Serializer, SvgRegistry } from 'survey-core';
import { ReactComponent as WidgetIcon } from 'assets/icons/widget.svg';
import ReactDOMServer from 'react-dom/server';

export const createCountryWidgetModel = () => {
  // create model for new question type
  class QuestionCountrywidgetModel extends Question {
    getType() {
      return 'dtcountrynew';
    }
    get countrywidgetType() {
      return this.getPropertyValue('countrywidgetType');
    }
    set countrywidgetType(val) {
      this.setPropertyValue('countrywidgetType', val);
    }
  }

  // set display title for question type
  localization.getLocale('').qt.dtcountrynew = 'Country Widget';

  const svg = ReactDOMServer.renderToString(<WidgetIcon />);
  SvgRegistry.registerIconFromSvg('dtcountrynew', svg);

  // this serializes the class into JSON
  Serializer.addClass(
    'dtcountrynew',
    [
      {
        name: 'countrywidgetType',
      },
    ],
    function () {
      return new QuestionCountrywidgetModel('');
    },
    'question'
  );

  Serializer.addProperties('dtcountrynew', [
    {
      name: 'name',
      readOnly: true,
    },
    {
      name: 'selectCountryPlaceholder:string',
      category: 'Locales',
      isLocalizable: true,
      default: 'Please select countries',
    },
    {
      name: 'searchCountryPlaceholder:string',
      category: 'Locales',
      isLocalizable: true,
      default: 'Search country...',
    },
    {
      name: 'inCountry:string',
      category: 'Locales',
      isLocalizable: true,
      default: 'in',
      displayName: 'in {country}',
    },

    {
      name: 'languagesText:string',
      category: 'Locales',
      isLocalizable: true,
      default: 'Languages',
    },
    {
      name: 'languagesChooseText:string',
      category: 'Locales',
      isLocalizable: true,
      default: 'Choose from the suggested languages.',
    },
    {
      name: 'noLangSelected:string',
      category: 'Locales',
      isLocalizable: true,
      default: 'Select at least one of suggested languages.',
      displayName: 'Error text if country has no selected languages',
    },
    {
      name: 'noLangSelectedGlobal:string',
      category: 'Locales',
      isLocalizable: true,
      default: 'Please correct errors bellow ',
      displayName: 'Global Error text if country has no selected languages',
    },
    {
      name: 'countryList',
      type: 'countryList',
      category: 'Countries',
      displayName: 'You  can edit list of countries and its languages',
    },
  ]);

  SurveyQuestionEditorDefinition.definition.countrywidget = {
    properties: [{ name: 'countrywidgetType', tab: 'layout' }],
  };

  ElementFactory.Instance.registerElement('dtcountrynew', (name) => {
    return new QuestionCountrywidgetModel(name);
  });

  PropertyGridEditorCollection.register({
    fit: function (prop: { type: string }) {
      return prop.type === 'dtcountrynew';
    },
    getJSON: function () {
      return { type: 'dtcountrynew' };
    },
  });
};
